// src/pages/Admin/Concierge.jsx
import React, { useEffect, useState } from "react";
import axios from "../../../../utils/cmsAxios";
import AdsSwiper from "../../../Ads/components/detailComponents/AdsSwiper";

const ConciergeSystemList = () => {
    // 전체 매장 리스트
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // 생성된 리스트
    const [totalList, setTotalList] = useState([]);
    const [weekday, setWeekday] = useState("");

    useEffect(() => {
        const daysOfWeek = [
            "일요일",
            "월요일",
            "화요일",
            "수요일",
            "목요일",
            "금요일",
            "토요일",
        ];
        const today = new Date().getDay();
        setWeekday(daysOfWeek[today]);
    }, []);

    // 전체 리스트 불러오기 함수
    const fetchList = async () => {
        try {
            setLoading(true);
            setError("");

            const { data } = await axios.get(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/select/concierge/system/list`
            );
            setItems(data.items || []);
        } catch (err) {
            console.error("[admin/concierge/list] error:", err);
            setError(
                err?.response?.data?.detail ||
                err?.response?.data?.message ||
                "컨시어지 신청 리스트 조회 중 오류가 발생했습니다."
            );
        } finally {
            setLoading(false);
        }
    };

    // 처음 로딩 시 전체 리스트
    useEffect(() => {
        fetchList(); // 빈 필터로 호출 → 전체 리스트
    }, []);

    // 1분마다 test/interval 호출
    // 2) 목록이 로딩된 후에만 10분마다 /test/interval 호출
    useEffect(() => {
        // 아직 승인된 매장이 없으면 interval 돌릴 필요 X
        if (!items || items.length === 0) return;

        const callIntervalApi = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/test/interval`
                );
                setTotalList(response.data.results);
            } catch (err) {
                console.error("[test/interval] error:", err);
            }
        };

        // ✅ 리스트가 준비된 시점에 한 번 실행
        callIntervalApi();

        // ✅ 이후 10분(60,000ms * 10)마다 반복 호출
        const timerId = setInterval(callIntervalApi, 60 * 1000 * 10);

        // 언마운트나 items 변경 시 인터벌 정리
        return () => clearInterval(timerId);
    }, [items.length]);

    const findResultByUserId = (uid) => {
        return totalList.find((item) => item.user_id === uid);
    };



    return (
        <div className="min-h-screen bg-neutral-50">
            <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow mt-6">
                <div className="flex">
                    <div className="flex-1 min-w-0 bg-neutral-50/70">
                        <main className="pt-6 flex flex-col p-4 w-full">
                            <h1 className="text-lg font-semibold mb-4">
                                컨시어지 시스템 전체 리스트
                            </h1>

                            {/* 에러 표시 */}
                            {error && (
                                <div className="mb-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                                    {error}
                                </div>
                            )}

                            {/* 로딩 */}
                            {loading ? (
                                <div className="py-10 text-center text-sm text-neutral-500">
                                    로딩 중입니다...
                                </div>
                            ) : (
                                <section className="px-4 pb-4 w-full overflow-x-auto">
                                    {items.length === 0 ? (
                                        <div className="py-10 text-center text-sm text-neutral-500">
                                            승인된 컨시어지 매장이 존재하지 않습니다.
                                        </div>
                                    ) : (
                                        <table className="min-w-full text-sm border-t border-neutral-200">
                                            <thead className="bg-neutral-50">
                                                <tr>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        ID
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        이름
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        전화
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        매장명
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        메뉴
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        상태
                                                    </th>
                                                    <th className="px-2 py-2 border-b text-center text-xs text-neutral-500">
                                                        이미지
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-neutral-100">
                                                {items.map((item) => {
                                                    // 1) totalList 에서 이 user_id 결과 찾기
                                                    const result = findResultByUserId(item.id);  // ⬅️ 여기서 사용

                                                    return (
                                                        <tr key={item.id} className="odd:bg-neutral-50/40">

                                                            {/* ID */}
                                                            <td className="px-2 py-2 border-b text-center text-xs text-neutral-700 whitespace-nowrap">
                                                                {item.id}
                                                            </td>

                                                            {/* 이름 */}
                                                            <td className="px-2 py-2 border-b text-center text-sm text-neutral-900 whitespace-nowrap">
                                                                {item.user_name}
                                                            </td>

                                                            {/* 전화 */}
                                                            <td className="px-2 py-2 border-b text-center text-sm text-neutral-700 whitespace-nowrap">
                                                                {item.phone}
                                                            </td>

                                                            {/* 매장명 */}
                                                            <td className="px-2 py-2 border-b text-center text-sm text-neutral-900 whitespace-nowrap">
                                                                {item.store_name}
                                                            </td>


                                                            {/* 메뉴 */}
                                                            <td className="px-2 py-2 border-b text-center text-sm text-neutral-900 whitespace-nowrap">
                                                                {[item.menu_1, item.menu_2, item.menu_3]
                                                                    .filter(Boolean)
                                                                    .join("/") || "-"}
                                                            </td>


                                                            {/* 상태 */}
                                                            <td className="px-2 py-2 border-b text-center text-xs text-neutral-700 whitespace-nowrap">
                                                                {item.status}
                                                            </td>

                                                            {/* 이미지 + AdsSwiper */}
                                                            <td className="px-2 py-2 border-b text-xs text-neutral-700 whitespace-nowrap">
                                                                {result ? (
                                                                    <div className="flex justify-center py-2">
                                                                        <div className="w-[360px] md:w-[420px]">

                                                                            {/* ⭐ AdsSwiper 적용 */}
                                                                            <AdsSwiper
                                                                                imageTemplateList={result.origin_image.map(
                                                                                    (img) => `data:image/png;base64,${img}`
                                                                                )}
                                                                                content={String(result.copyright)
                                                                                    .replace(/["']/g, "")
                                                                                    .trim()}
                                                                                title={result.title || "1"}
                                                                                useOption={result.channel || "1"}
                                                                                checkImages={[]} // 선택 안 쓰면 빈 배열
                                                                                handleImageClick={() => { }} // 필요 없으면 빈 함수
                                                                                storeName={result.store_name}
                                                                                roadName={result.road_name}
                                                                                weather={result.main}
                                                                                tag={result.detail_category_name}
                                                                                weekday={weekday}
                                                                                checkedBox={false}

                                                                                // 🔥 추가: 자동 업로드 모드 + 콜백
                                                                                autoUpload={true}
                                                                                onAutoUpload={async ({ imageDataUrl, copyrightText }) => {
                                                                                    try {
                                                                                        await axios.post(
                                                                                            `${process.env.REACT_APP_FASTAPI_ADS_URL}/auto/upload/instagram`,
                                                                                            {
                                                                                                user_id: result.user_id,
                                                                                                channel: result.channel,            // 같이 보내기
                                                                                                register_tag: result.register_tag,  // 같이 보내기
                                                                                                caption: copyrightText,          // AdsSwiper에서 넘어온 텍스트
                                                                                                image_base64: imageDataUrl,               // 캡처된 최종 이미지 dataURL
                                                                                            }
                                                                                        );
                                                                                    } catch (err) {
                                                                                        console.error("[upload/instagram] error:", err);
                                                                                    }
                                                                                }}
                                                                            />


                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    // 광고 생성 중일 경우
                                                                    <span className="text-neutral-400 text-xs">생성중...</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>

                                        </table>
                                    )}
                                </section>
                            )}
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConciergeSystemList;
